import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';

interface SendButtonProps {
	onClick: () => void;
	isValid: boolean;
	isLoading: boolean;
	label?: string;
}

function SendButton({ onClick, isValid, isLoading, label = 'Send' }: SendButtonProps) {
	return (
		<Button
		variant="contained"
		color="primary"
		disabled={!isValid || isLoading}
		startIcon={!isLoading ? <SendIcon /> : null}
		onClick={onClick}
		sx={{ 
			width: '100%', 
			display: 'flex', 
			justifyContent: 'center', 
			alignItems: 'center', 
			gap: 1 
		}}
		>
			{isLoading ? <CircularProgress size={24} sx={{ marginTop: '1px', marginBottom: '1px' }} /> : label}
		</Button>
	);
};

export default SendButton;
